// extracted by mini-css-extract-plugin
module.exports = {"termsSection":"TermsAndConditions_termsSection__2fDkM","main":"TermsAndConditions_main__2qm3h","main__subHeading":"TermsAndConditions_main__subHeading__2fE0i"};